import { useSafeIntl } from "@bloomberg/media.i18n";

export const useIntl = useSafeIntl;
